import { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
import { getMUICache, getUrl, getEndpoint, getCookie, setCookie, getImageUrl, getImageSize, convertEpochTime, isLoggedIn } from '../../../common/utils';
import './SurveyShow.css';
import bcrypt from 'bcryptjs-react';
import { PAGEBUILDER_URLS } from "../../Common/Constant.js";

SurveyShow.version = 1000;
SurveyShow.lang = 'en';
SurveyShow.langs = ['en'];
SurveyShow.setLang = (lang: any) => {
    SurveyShow.lang = lang;
};

Object.defineProperty(SurveyShow, 'name', {
    writable: true,
    value: 'SurveyShow'
});

type CAPTCHA = { num1: number; num2: number; answer: number; userAnswer: string };

export function SurveyShow(props: any) {
    const [responses, setResponses] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [captcha, setCaptcha] = useState<CAPTCHA | null>(null);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [validationMessages, setValidationMessages] = useState<string[]>([]);
    const [submissionSuccess, setSubmissionSuccess] = useState<boolean>(false);
    const [surveyAvailable, setSurveyAvailable] = useState<boolean>(true); // State to manage survey availability

    const endpoint = getEndpoint(props);

    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, [endpoint]);

    useEffect(() => {
        if (endpoint.isSSR && endpoint.SSRDataObj && Object.keys(responses).length === 0) {
            setResponses(endpoint.SSRDataObj);
            // if(endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length > 0) {
            //     setCmsSeoData(props, endpoint.SSRDataObj.items[0], "QuizShow");
            // }
        }
        if (responses && responses.items && responses.items[0] && responses.items[0].it && responses.items[0].it.primeId) {
            isLoggedIn();
        }
    }, [endpoint.SSRDataObj]);

    useEffect(() => {
        const cookieExists = checkCookie('surveyTaken');
        setSurveyAvailable(!cookieExists); // Set survey availability based on cookie
    }, []);

    useEffect(() => {
        if (surveyAvailable) {
            generateCaptcha();
        }
    }, [surveyAvailable]);
    let cdsDomain = '';
    if (typeof props.CONSTANTS.CDS_API !== "undefined") {
        cdsDomain = props.CONSTANTS.CDS_API;
    } else {
        cdsDomain = props.CONSTANTS.API_URL.CDS_API;
    }

    let requestId2: any = null;
    let REQUEST_URL: any = null;
    if (!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)))) {
        if (props && props.REQUEST_URL) {
            REQUEST_URL = props.REQUEST_URL;
        }
        const idMatch = REQUEST_URL.match(/\/(\d+)\.html/);
        requestId2 = idMatch ? idMatch[1] : null;
    }

    const fetchComponentData = () => {
        getData(getUrl(props, 1, false, 'MAIN', true));
    };

    const getData = (url: any) => {
        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(url, { headers: headers })
            .then(response => response.json())
            .then(response => {
                setResponses(response);
                // if(response.items && response.items.length > 0) {
                //     setCmsSeoData(props, response.items[0], "SurveyShow");
                // }
            })
            .catch(err => {
                //console.log("Exception => ", err);
            });
    };

    const handleInputChange = (questionId: any, value: any) => {
        setResponses((prevResponses: any) => ({
            ...prevResponses,
            [questionId]: value
        }));
    };

    const renderQuestion = (question: any) => {
        switch (question?.cmstype) {
            case 'SURVEYMCQSINGLECHOICE':
                return (
                    <>
                        {/* <h3 className='ThemeThreeQuizTitleQuestionWrap'>{question?.title}</h3> */}
                        <div className='ThemeThreeQuizSurveyQuestionWrap' key={question?.title}>
                            {question?.options.map((option: any) => (
                                <div className='ThemeThreeSurveyTitleAnswerInnerWrap'>
                                    <div className='radio-button-container' key={option.id}>
                                        <label>
                                            <input
                                                type="radio"
                                                name={question.title}
                                                value={option.id}
                                                onChange={(e) => handleInputChange(question?.title, e.target.value)}
                                            />
                                            {option.option}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                );
            case 'SURVEYMCQMULTICHOICE':
                return (
                    <>
                        {/* <h3 className='ThemeThreeQuizTitleQuestionWrap'>{question.title}</h3> */}
                        <div className='ThemeThreeQuizSurveyQuestionWrap' key={question.title}>
                            {question.options.map((option: any) => (
                                <div className='ThemeThreeSurveyTitleAnswerInnerWrap'>
                                    <div className='radio-button-container' key={option.id}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                value={option.id.toString()}
                                                onChange={(e) => handleInputChange(question?.title, e.target.checked ? [...(responses[question?.title] || []), option.id.toString()] : (responses[question?.title] || []).filter((o: any) => o !== option.id.toString()))}
                                            />
                                            {option.option}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                );
            case 'SUBJECTIVEQUESTION':
                return (
                    <>
                        {/* <h3 className='ThemeThreeQuizTitleQuestionWrap'>{question.title}</h3> */}
                        <div className='ThemeThreeQuizSurveyQuestionWrap' key={question.title}>
                            <textarea placeholder='Type your anwer here'
                                onChange={(e) => handleInputChange(question.title, e.target.value)}
                            />
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    const generateClientId = () => {
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 1000);
        return `${timestamp}-${randomNum}`;
    };

    const validateSurvey = (): string[] => {
        const missingQuestions: string[] = [];
        const questions = responses.items[0].sections.flatMap((section: any) => section.questionpackages);
        questions.forEach((question: any, index: number) => {
            const response = responses[question.title];
            if (question.cmstype === 'SUBJECTIVEQUESTION' && !response) {
                missingQuestions.push(`Question ${index + 1} has not been answered.`);
            } else if (question.cmstype !== 'SUBJECTIVEQUESTION' && !response) {
                missingQuestions.push(`Question ${index + 1} has not been answered.`);
            }
        });

        return missingQuestions;
    };

    const preparePayload = () => {
        const answers = responses.items[0].sections[0].questionpackages.map((question: any) => {
            const response = responses[question.title];
            if (question.cmstype === 'SUBJECTIVEQUESTION') {
                return {
                    questionId: Number(question.msid),
                    textResponse: response || ''
                };
            }
            return {
                optionSelected: Array.isArray(response) ? response : [response],
                questionId: Number(question.msid)
            };
        });
        return {
            answers,
            endTime: Date.now(),
            hostId: props.clientHostId,
            quizForm: {},
            quizId: responses?.items?.[0]?.id,
            startTime: 0,
            userIdentifier: {
                clientid: generateClientId()
            }
        };
    };

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);
        setValidationMessages([]);
        setErrorMessage('');
        setSubmissionSuccess(false);

        // Validate questions
        const validationMsgs = validateSurvey();
        if (validationMsgs.length > 0) {
            setValidationMessages(validationMsgs);
            setLoading(false);
            return;
        }

        if (!validateCaptcha()) {
            setErrorMessage('Captcha answer is incorrect.');
            setLoading(false);
            return;
        }

        try {
            const payload = preparePayload();
            let headerString: string = JSON.stringify(payload);
            headerString = bcrypt.hashSync(headerString, 6);
            const headers = { 'p-nonce': headerString, 'Content-Type': 'application/json' };
            const response = await fetch(`${cdsDomain}/cds-feed-ext/submit/survey/m360`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }

            //const result = await response.json();
            //console.log('Survey submitted successfully:', result);
            setSubmissionSuccess(true);
            setCookie('surveyTaken', requestId2, 1); // Set the cookie to prevent future participation for 1 day
        } catch (err) {
            setError('Failed to submit survey. Please try again.');
            console.error('Submission error:', err);
        } finally {
            setLoading(false);
        }
    };

    const generateCaptcha = () => {
        const num1 = Math.floor(Math.random() * 10) + 1;
        const num2 = Math.floor(Math.random() * 10) + 1;
        const answer = num1 + num2;

        setCaptcha({
            num1,
            num2,
            answer,
            userAnswer: ''
        });
    };

    const handleCaptchaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setCaptcha(prevCaptcha => ({
            ...prevCaptcha!,
            userAnswer: value
        }));
    };

    const validateCaptcha = () => {
        if (captcha) {
            const userAnswer = parseInt(captcha.userAnswer, 10);
            return userAnswer === captcha.answer;
        }
        return false;
    };

    const checkCookie = (name: string) => {
        return getCookie(name) == requestId2;
    };

    const renderQuiz = () => {
        if (Object.keys(responses).length === 0) {
            return <div>Loading...</div>;
        }

        return responses.items[0].sections.map((section: any) => (
            <div key={section.msid} className="ThemeThreeQuizQuestionAnswerWrap">
                {section.questionpackages.map((question: any) => (

                    <>
                        <div className='ThemeThreeQuizTitleQuestionWrap'>{question?.title} {question.required && <span style={{ color: 'red' }}>*</span>}
                        </div>
                        <div className='ThemeThreeQuizSurveyWrapImage'> {renderQuestion(question)}

                            <div key={question.msid} className='ThemeThreeSurvaymainImageWrap'>
                                <div className='ThemeThreeSurveyImageWrap'>
                                    {question.thumbsize > 0 && (
                                        <img
                                            src={getImageUrl(question.msid, question.thumbsize, 143, 108, "", false, props.CONSTANTS)}
                                            width="145"
                                            height="100"
                                            alt={question?.title}
                                            title={question?.title}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ))}
            </div>
        ));
    };
    const getRenderPart = () => {
        return (
            <CacheProvider value={getMUICache()}>
                <div className='story-wrapper'>
                    <div className="ThemeThreeQuizeHeadingWrap">
                        <div className='ThemeThreeQuizeImageWrap'>
                            {<img src={getImageUrl(responses?.items?.[0]?.id, getImageSize(responses?.items?.[0]?.imageid), 143, 108, "", false, props.CONSTANTS)} width="145" height="100" alt="Quiz Thumbnail" />}
                        </div>
                        <div className='ThemeThreeQuizeShowHeadingWrapper'>
                            <h1 className="ThemeThreeQuizeShowHeading" dangerouslySetInnerHTML={{ __html: responses?.items?.[0]?.hl }}></h1>
                            <div className='ThemeThreeQuizeAuthorWrap'>{convertEpochTime(responses?.items?.[0]?.lpt, 'updated', "DD MMM YYYY")} - {responses?.items?.[0]?.authors?.[0].name} - {responses?.items?.[0]?.ag}</div>
                            <div className='ThemeThreeQuizeDataWrap' dangerouslySetInnerHTML={{ __html: responses?.items?.[0]?.syn }}></div>
                        </div>
                    </div>
                </div>
            </CacheProvider>
        );
    };

    return (
        <CacheProvider value={getMUICache()}>
            <div className='ThemeThreeOutherWrapperMainWrapper ThemeThreeOutherSurveyWrapperMainWrapper'>
                {getRenderPart()}
                {typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)) && renderQuiz()}
                {submissionSuccess ? (
                    <>
                        <div className='ThemeThreeThanks'>
                            <p>Thank you for taking the time to participate in our recent survey. <br />
                                Your feedback is incredibly valuable to us, and we truly appreciate your input.</p>

                        </div>
                        <div className='themeThreeQuizButton' style={{ marginTop: '10px' }}>
                            <a href={`/${responses?.items?.[0]?.seourl}/surveylist/${responses?.items?.[0]?.folderId}.html`}><button>Take More Survey</button></a>
                        </div>
                    </>
                ) : (
                    surveyAvailable ? (
                        <>
                            {renderQuiz()}
                            {captcha && (
                                <div className='ThemeThreeQuizeQustionWrap'>
                                    <p>What is {captcha.num1} + {captcha.num2}?</p>
                                    <input
                                        type="text"
                                        value={captcha.userAnswer}
                                        onChange={handleCaptchaChange}
                                    />
                                </div>
                            )}
                            <button className='QuizSubmitButton' onClick={handleSubmit} disabled={loading}>
                                {loading ? 'Submitting...' : 'Submit'}
                            </button>
                            {validationMessages.length > 0 && (
                                <div className='ThemeThreeErrorWrap'>
                                    {validationMessages.map((msg, index) => (
                                        <p key={index} style={{ color: 'red' }}>{msg}</p>
                                    ))}
                                </div>
                            )}
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                        </>
                    ) : (
                        <p className='SurveyMessageThemeThree'>You've already submitted this survey. Thank you!</p>
                    )
                )}
            </div>

            <div className='QuizSurvetWrapper'>
                <p className='disclaimerQuizSurvey'>DISCLAIMER:</p>
                <ul>
                    <li>Questions marked with red asterisk (*) are mandatory to answer </li>
                    <li>Legal information is not legal advice, read the disclaimer. The information provided on this site is not legal advice, does not constitute a lawyer referral service, and no attorney-client or confidential relationship is or will be formed by use of the site.</li>
                </ul>
            </div>
        </CacheProvider>
    );
}
